<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Indicadores — Documentos
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Em
        strong  Indicadores → Documentos
        |  há relatórios tabulares, gráficos e mapas sobre documentos.
        |  Cada card só aparece se você tiver a permissão correspondente.

      h5.h5 1. Abrir o hub
      ol
        li No menu lateral, abra
          strong  Indicadores
          | .
        li Clique em
          strong  Documentos
          | .
      figure.manual-figure
        img(:src="imgHub" alt="Hub de indicadores de Documentos")

      h5.h5 2. Relatório com gráfico e tabela
      ol
        li Abra um card (ex.:
          strong  Por situação
          | ).
        li Em
          strong  Filtrar
          | , ajuste datas e critérios.
        li Clique no ícone de
          strong  funil
          |  para aplicar e use a
          strong  impressora
          |  para imprimir.
      figure.manual-figure
        img(:src="imgReport" alt="Documentos por situação")

      h5.h5 3. Mapas
      ol
        li Em
          strong  Pontos no mapa
          |  ou
          strong  Densidade no mapa
          | , filtre e aguarde o carregamento.
        li Nos pontos, clusters mostram a quantidade; zoom e clique abrem detalhes.
      figure.manual-figure
        img(:src="imgMapa" alt="Documentos Pontos no mapa")

      h5.h5 4. Relatórios do hub
      p Permissões no formato
        strong  Indicadores → Documentos → …
        | :
      ul
        li
          strong  Por modelo
          |  — quantidade por modelo.
          |  Permissão:
          strong  Modelos de documento
          | .
        li
          strong  Por modelo X Situação
          |  — cruzamento modelo e situação.
          |  Permissão:
          strong  Modelos por situações
          | .
        li
          strong  Valor mensal
          |  — valores por mês.
          |  Permissão:
          strong  Valores mensais
          | .
        li
          strong  Por situação
          |  — quantidade por situação.
          |  Permissão:
          strong  Situações
          | .
        li
          strong  Por situação do comentário
          |  — quantidade por status do comentário.
          |  Permissão:
          strong  Status
          | .
        li
          strong  Por zona
          |  — quantidade por zona.
          |  Permissão:
          strong  Zonas
          | .
        li
          strong  Por fiscal
          |  — quantidade por fiscal.
          |  Permissão:
          strong  Fiscais
          | .
        li
          strong  Por reincidência
          |  — quantidade por reincidência.
          |  Permissão:
          strong  Reincidências
          | .
        li
          strong  Por Grupo
          |  — quantidade por grupo.
          |  Permissão:
          strong  Grupos
          | .
        li
          strong  Por tipo de documento
          |  — quantidade por tipo.
          |  Permissão:
          strong  Tipos
          | .
        li
          strong  Por faixa de valor
          |  — quantidade por faixa.
          |  Permissão:
          strong  Faixa de valores
          | .
        li
          strong  Implantados
          |  — documentos implantados.
          |  Permissão:
          strong  Implantados
          | .
        li
          strong  Pontos no mapa
          |  /
          strong  Densidade no mapa
          |  — localização e incidência.
          |  Permissões:
          strong  Mapas → Pontos
          |  /
          strong  Densidade
          | .
        li
          strong  Por fiscal e meses
          |  /
          strong  Por fiscal e dias
          |  — quantidade por fiscal no tempo.
          |  Permissões:
          strong  Fiscais por meses
          |  /
          strong  Fiscais por dias
          | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgHub: require("@/assets/manuais/31-indicadores-docs-hub.png"),
      imgReport: require("@/assets/manuais/31a-indicadores-docs-por-situacao.png"),
      imgMapa: require("@/assets/manuais/31b-indicadores-docs-mapa-pontos.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px
</style>
